import {twMerge} from "tailwind-merge";
import {cva, VariantProps} from "class-variance-authority";

const badge = cva(
  "inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset",
  {
    variants: {
      variant: {
        default:
          "bg-surface-container-high text-on-surface-variant ring-surface-container-high",
        primary: "bg-primary text-on-primary ring-primary",
        secondary: "bg-secondary text-on-secondary ring-secondary",
        tertiary: "bg-tertiary text-on-tertiary ring-tertiary",
        error: "bg-error text-on-error ring-error",
        success: "bg-success text-on-success ring-success",
        warning: "bg-warning text-on-warning ring-warning",
        info: "bg-info text-on-info ring-info",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badge> {}

/**
 * Badge component for displaying status or labels.
 */
const Badge = ({className, variant, ...props}: BadgeProps) => {
  return <div className={twMerge(badge({variant, className}))} {...props} />;
};

export default Badge;
